// ============================================================
// Maha Kumbh AI — Simhastha AI Command Assurance Platform
// Simhastha Kumbh 2027 · Nashik & Trimbakeshwar, Maharashtra
// ============================================================

// ── Executive KPIs ──────────────────────────────────────────
export const kpiData = [
  { id:1, title:"Active Pilgrims",     value:"6,84,210", trend:+14.2, icon:"Users",         color:"info",    sparkline:[420,490,540,600,640,684] },
  { id:2, title:"Crowd Risk Index",    value:"5.8 / 10", trend:-4.2,  icon:"AlertTriangle", color:"warning", sparkline:[7.4,7.0,6.6,6.1,5.9,5.8] },
  { id:3, title:"Active Incidents",   value:"18",       trend:-22.4, icon:"Zap",            color:"danger",  sparkline:[28,24,22,21,19,18] },
  { id:4, title:"Emergency Responses",value:"6",        trend:0,     icon:"Siren",          color:"danger",  sparkline:[3,5,4,7,5,6] },
  { id:5, title:"Missing Persons",    value:"11",       trend:-31.0, icon:"UserSearch",     color:"warning", sparkline:[18,16,14,13,12,11] },
  { id:6, title:"Medical Cases",      value:"142",      trend:+3.6,  icon:"HeartPulse",     color:"success", sparkline:[112,120,128,134,138,142] },
  { id:7, title:"Transport Load",     value:"74%",      trend:+4.1,  icon:"Bus",            color:"info",    sparkline:[58,63,67,70,72,74] },
  { id:8, title:"AI Confidence",      value:"93.7%",    trend:+1.4,  icon:"Brain",          color:"purple",  sparkline:[89,90,91,92,93,93.7] },
];

export const topStats = { totalAlerts:75, openCases:18, closedCases:57, escalations:6 };

// ── Alert feed ───────────────────────────────────────────────
export const alertFeed = [
  { id:1, time:"14:32", type:"danger",  title:"Crowd surge at Ramkund Ghat — Entry 2",           dept:"Police",        status:"Active",      priority:"HIGH"  },
  { id:2, time:"14:28", type:"warning", title:"Water station #8 at 91% capacity — Panchvati",     dept:"Municipal",     status:"Monitoring",  priority:"MED"   },
  { id:3, time:"14:21", type:"info",    title:"Shuttle SR-04 delayed 22 min — Trimbakeshwar",     dept:"Transport",     status:"In Progress", priority:"LOW"   },
  { id:4, time:"14:15", type:"danger",  title:"Medical emergency — heatstroke Zone C Godavari",  dept:"Health",        status:"Responded",   priority:"HIGH"  },
  { id:5, time:"14:09", type:"warning", title:"Missing child reported at Panchvati Sector 7",     dept:"Police",        status:"Active",      priority:"HIGH"  },
  { id:6, time:"14:02", type:"info",    title:"AI duplicate alert suppressed — Kalaram Zone",     dept:"AI Assurance",  status:"Auto-Closed", priority:"LOW"   },
  { id:7, time:"13:55", type:"warning", title:"Shelter capacity 94% — Nashik Road Camp 3",        dept:"Revenue",       status:"Monitoring",  priority:"MED"   },
  { id:8, time:"13:48", type:"success", title:"Missing person resolved — ID #MP-1182",             dept:"Police",        status:"Closed",      priority:"MED"   },
  { id:9, time:"13:40", type:"danger",  title:"Fire alert suppressed (false positive) — Trimbak", dept:"AI Assurance",  status:"Validated",   priority:"HIGH"  },
  { id:10,time:"13:32", type:"info",    title:"New pilgrim guidance broadcast — Marathi/Hindi",   dept:"Public Comms",  status:"Published",   priority:"LOW"   },
];

export const alertSeverityBreakdown = [
  { name:"Critical", value:4,  color:"#EF4444" },
  { name:"High",     value:9,  color:"#F97316" },
  { name:"Medium",   value:14, color:"#F59E0B" },
  { name:"Low",      value:21, color:"#3B82F6" },
  { name:"Info",     value:27, color:"#64748B" },
];

// ── Crowd intelligence ───────────────────────────────────────
export const crowdTrendData = [
  { time:"05:00", actual:80000,  predicted:85000,  risk:2.8 },
  { time:"06:00", actual:160000, predicted:155000, risk:3.9 },
  { time:"07:00", actual:280000, predicted:275000, risk:5.2 },
  { time:"08:00", actual:420000, predicted:415000, risk:6.4 },
  { time:"09:00", actual:550000, predicted:545000, risk:7.1 },
  { time:"10:00", actual:630000, predicted:625000, risk:7.6 },
  { time:"11:00", actual:684210, predicted:680000, risk:5.8 },
  { time:"12:00", actual:null,   predicted:720000, risk:6.4 },
  { time:"13:00", actual:null,   predicted:760000, risk:7.0 },
  { time:"14:00", actual:null,   predicted:790000, risk:7.4 },
  { time:"15:00", actual:null,   predicted:810000, risk:7.8 },
  { time:"16:00", actual:null,   predicted:780000, risk:7.1 },
  { time:"17:00", actual:null,   predicted:710000, risk:6.2 },
  { time:"18:00", actual:null,   predicted:620000, risk:5.1 },
];

export const crowdFlowByZone = [
  { zone:"Ramkund Ghat",    current:92140, capacity:100000, density:9.2, risk:"critical", trend:"rising"   },
  { zone:"Panchvati",       current:81200, capacity:100000, density:8.1, risk:"high",     trend:"stable"   },
  { zone:"Trimbakeshwar",   current:76400, capacity:100000, density:7.6, risk:"high",     trend:"falling"  },
  { zone:"Nashik Road Stn", current:68100, capacity:100000, density:6.8, risk:"moderate", trend:"rising"   },
  { zone:"Kalaram Temple",  current:58200, capacity:100000, density:5.8, risk:"moderate", trend:"stable"   },
  { zone:"Gangapur Camp",   current:41800, capacity:100000, density:4.1, risk:"normal",   trend:"falling"  },
];

export const routeSaturation = [
  { route:"Ramkund Ghat — Main Entry",    load:92, capacity:100, status:"critical" },
  { route:"Panchvati — Godavari Bridge",  load:81, capacity:100, status:"high"     },
  { route:"Trimbakeshwar Temple Gate",    load:76, capacity:100, status:"high"     },
  { route:"Nashik Road — Bus Terminal",   load:68, capacity:100, status:"moderate" },
  { route:"Kalaram Temple Corridor",      load:58, capacity:100, status:"moderate" },
  { route:"Gangapur Camp Zone",           load:41, capacity:100, status:"normal"   },
];

export const crowdHeatmapHours = [
  { hour:"06:00", ramkund:28, panchvati:22, trimbak:18, nashikRd:15, kalaram:12, gangapur:8 },
  { hour:"08:00", ramkund:54, panchvati:42, trimbak:36, nashikRd:31, kalaram:24, gangapur:16 },
  { hour:"10:00", ramkund:82, panchvati:71, trimbak:64, nashikRd:58, kalaram:44, gangapur:28 },
  { hour:"11:00", ramkund:92, panchvati:81, trimbak:76, nashikRd:68, kalaram:58, gangapur:41 },
  { hour:"13:00", ramkund:88, panchvati:78, trimbak:71, nashikRd:64, kalaram:54, gangapur:38 },
  { hour:"15:00", ramkund:76, panchvati:68, trimbak:62, nashikRd:56, kalaram:48, gangapur:30 },
  { hour:"18:00", ramkund:48, panchvati:42, trimbak:36, nashikRd:34, kalaram:28, gangapur:18 },
];

// ── AI Assurance ────────────────────────────────────────────
export const aiAssuranceData = {
  accuracy:       93.7,
  falsePositives: 5.8,
  duplicates:     4.1,
  confidence:     91.2,
  humanValidated: 86.9,
  pendingReviews: 31,
  timeline:[
    { hour:"07:00", total:38,  validated:34, fp:2, dup:2 },
    { hour:"08:00", total:62,  validated:57, fp:3, dup:2 },
    { hour:"09:00", total:94,  validated:87, fp:4, dup:3 },
    { hour:"10:00", total:118, validated:109,fp:5, dup:4 },
    { hour:"11:00", total:86,  validated:79, fp:4, dup:3 },
    { hour:"12:00", total:72,  validated:66, fp:3, dup:3 },
    { hour:"13:00", total:54,  validated:50, fp:2, dup:2 },
  ],
};

export const aiModelHealth = [
  { model:"Crowd Density CNN",       accuracy:94.2, drift:0.8,  bias:"Low",   status:"Healthy",    reviewed:2180 },
  { model:"Stampede Risk LSTM",      accuracy:91.6, drift:1.4,  bias:"Low",   status:"Monitoring", reviewed:1840 },
  { model:"Missing Person Match",    accuracy:88.4, drift:2.1,  bias:"Medium",status:"Alert",      reviewed:420  },
  { model:"Alert Dedup Engine",      accuracy:96.1, drift:0.4,  bias:"Low",   status:"Healthy",    reviewed:3210 },
  { model:"Heatstroke Predictor",    accuracy:87.9, drift:1.8,  bias:"Low",   status:"Monitoring", reviewed:980  },
  { model:"Transport Surge Forecast",accuracy:89.3, drift:1.2,  bias:"Low",   status:"Healthy",    reviewed:1640 },
  { model:"Service Load Predictor",  accuracy:92.8, drift:0.6,  bias:"Low",   status:"Healthy",    reviewed:2420 },
];

export const humanReviewQueue = [
  { id:"RV-4421", alert:"Crowd surge AI flag — Entry 4 Ramkund",   model:"Crowd Density CNN",    confidence:72, time:"14:28", status:"Pending",    assignee:"UNIT-P22"    },
  { id:"RV-4420", alert:"Missing person face match #MP-1185",       model:"Missing Person Match", confidence:61, time:"14:22", status:"Reviewing",  assignee:"UNIT-P16"  },
  { id:"RV-4419", alert:"Heatstroke cluster prediction Zone D",      model:"Heatstroke Predictor", confidence:78, time:"14:18", status:"Pending",    assignee:"UNIT-H05"  },
  { id:"RV-4418", alert:"Transport surge — Nashik Road 14:00–16:00",model:"Transport Surge",      confidence:84, time:"14:11", status:"Approved",   assignee:"RTO Officer"   },
  { id:"RV-4417", alert:"Shelter overload prediction — Camp 3",      model:"Service Load",         confidence:89, time:"14:05", status:"Approved",   assignee:"DM Revenue"    },
  { id:"RV-4416", alert:"Fire alarm — possible false positive",       model:"Alert Dedup Engine",   confidence:43, time:"13:58", status:"Rejected",   assignee:"SP Nashik"     },
];

// ── Department & resources ───────────────────────────────────
export const departmentStatus = [
  { name:"Police",        active:6420,  total:7000,  alerts:10, resolved:87, color:"#2563EB" },
  { name:"Health",        active:1680,  total:2000,  alerts:5,  resolved:92, color:"#10B981" },
  { name:"Transport",     active:1120,  total:1300,  alerts:6,  resolved:78, color:"#F59E0B" },
  { name:"Municipal NMC", active:840,   total:1000,  alerts:3,  resolved:94, color:"#7C3AED" },
  { name:"NDRF",          active:420,   total:500,   alerts:2,  resolved:96, color:"#EF4444" },
  { name:"Revenue",       active:360,   total:400,   alerts:1,  resolved:98, color:"#64748B" },
];

export const resourceDeployment = [
  { zone:"Ramkund Ghat",   police:1840, health:280, volunteers:420, ambulance:8, fire:3, status:"critical" },
  { zone:"Panchvati",      police:1220, health:180, volunteers:310, ambulance:6, fire:2, status:"high"     },
  { zone:"Trimbakeshwar",  police:980,  health:140, volunteers:280, ambulance:5, fire:2, status:"high"     },
  { zone:"Nashik Road Stn",police:820,  health:120, volunteers:210, ambulance:4, fire:1, status:"moderate" },
  { zone:"Kalaram Temple", police:640,  health:90,  volunteers:160, ambulance:3, fire:1, status:"moderate" },
  { zone:"Gangapur Camp",  police:420,  health:60,  volunteers:100, ambulance:2, fire:1, status:"normal"   },
];

export const emergencyUnits = [
  { type:"Police",     deployed:58,  available:22,  responding:6,  color:"#2563EB", icon:"Shield"    },
  { type:"Ambulance",  deployed:34,  available:14,  responding:5,  color:"#EF4444", icon:"Ambulance" },
  { type:"Fire",       deployed:18,  available:8,   responding:1,  color:"#F59E0B", icon:"Flame"     },
  { type:"NDRF",       deployed:10,  available:6,   responding:0,  color:"#7C3AED", icon:"HardHat"   },
  { type:"Volunteers", deployed:480, available:240, responding:28, color:"#10B981", icon:"Heart"     },
];

// ── Services ─────────────────────────────────────────────────
export const serviceStress = [
  { name:"Toilets",        used:89, capacity:100, count:"5,800 units",  status:"critical" },
  { name:"Water Stations", used:74, capacity:100, count:"960 stations", status:"moderate" },
  { name:"Shelters",       used:93, capacity:100, count:"380 camps",    status:"critical" },
  { name:"Parking Lots",   used:71, capacity:100, count:"52 zones",     status:"moderate" },
  { name:"Medical Camps",  used:61, capacity:100, count:"210 camps",    status:"moderate" },
  { name:"Food Zones",     used:82, capacity:100, count:"720 stalls",   status:"high"     },
  { name:"Bus Bays",       used:78, capacity:100, count:"260 bays",     status:"high"     },
  { name:"Waste Points",   used:66, capacity:100, count:"1,400 bins",   status:"moderate" },
];

export const serviceZoneBreakdown = [
  { zone:"Ramkund Ghat",   water:88, toilets:94, shelter:91, food:86, medical:72, parking:78 },
  { zone:"Panchvati",      water:74, toilets:82, shelter:78, food:76, medical:61, parking:68 },
  { zone:"Trimbakeshwar",  water:68, toilets:76, shelter:74, food:72, medical:58, parking:62 },
  { zone:"Nashik Road Stn",water:62, toilets:68, shelter:64, food:66, medical:51, parking:74 },
  { zone:"Kalaram Temple", water:54, toilets:61, shelter:58, food:62, medical:44, parking:56 },
  { zone:"Gangapur Camp",  water:42, toilets:48, shelter:44, food:48, medical:36, parking:41 },
];

// ── Emergency response ────────────────────────────────────────
export const activeIncidents = [
  { id:"INC-8821", title:"Crowd surge density >9/m²",    zone:"Ramkund Ghat, Entry 2",   priority:"CRITICAL", dept:"Police",    status:"Responding", elapsed:"08:42", eta:"14:50" },
  { id:"INC-8820", title:"Water tanker not arrived",      zone:"Panchvati Water Point 8", priority:"HIGH",     dept:"Municipal", status:"In Progress",elapsed:"12:18", eta:"15:15" },
  { id:"INC-8819", title:"Ambulance access blocked",      zone:"Camp Beta, Trimbak Rd",   priority:"CRITICAL", dept:"Health",    status:"Escalated",  elapsed:"06:24", eta:"14:44" },
  { id:"INC-8818", title:"Shelter overload Camp 3",       zone:"Nashik Road Camp 3",      priority:"HIGH",     dept:"Revenue",   status:"Monitoring", elapsed:"22:10", eta:"16:00" },
  { id:"INC-8817", title:"Missing child — Panchvati Sec7",zone:"Panchvati, Sector 7",     priority:"HIGH",     dept:"Police",    status:"Active",     elapsed:"05:12", eta:"15:00" },
  { id:"INC-8816", title:"Heatstroke cluster — Zone D",   zone:"Godavari Zone D",         priority:"HIGH",     dept:"Health",    status:"Responded",  elapsed:"18:44", eta:"Done"  },
];

export const responseTimeline = [
  { time:"05:30", incidents:2, resolved:2, escalated:0 },
  { time:"06:00", incidents:4, resolved:3, escalated:1 },
  { time:"07:00", incidents:8, resolved:6, escalated:1 },
  { time:"08:00", incidents:14,resolved:11,escalated:2 },
  { time:"09:00", incidents:18,resolved:14,escalated:3 },
  { time:"10:00", incidents:22,resolved:17,escalated:4 },
  { time:"11:00", incidents:18,resolved:15,escalated:2 },
  { time:"12:00", incidents:15,resolved:12,escalated:1 },
  { time:"13:00", incidents:12,resolved:10,escalated:1 },
  { time:"14:00", incidents:10,resolved:7, escalated:2 },
];

// ── Health ────────────────────────────────────────────────────
export const healthData = {
  heatstroke:        28,
  dehydration:       74,
  minorInjury:       34,
  seriousCase:        9,
  hospitalReferrals:  4,
  ambulanceActive:    5,
  trend:[
    { time:"06:00", heatstroke:2,  dehydration:8,  injury:4  },
    { time:"07:00", heatstroke:6,  dehydration:18, injury:8  },
    { time:"08:00", heatstroke:11, dehydration:31, injury:14 },
    { time:"09:00", heatstroke:18, dehydration:49, injury:22 },
    { time:"10:00", heatstroke:23, dehydration:62, injury:29 },
    { time:"11:00", heatstroke:28, dehydration:74, injury:34 },
  ],
  camps:[
    { name:"Camp Alpha — Ramkund",  load:62, capacity:50, status:"over"   },
    { name:"Camp Beta — Panchvati", load:41, capacity:50, status:"normal" },
    { name:"Camp Gamma — Trimbak",  load:47, capacity:50, status:"near"   },
    { name:"Civil Hospital Ref.",   load:4,  capacity:20, status:"normal" },
  ],
};

export const healthRiskZones = [
  { zone:"Ramkund Ghat",   heatRisk:82, dehydrationRisk:78, injuryRisk:64, epidemicRisk:24, overallRisk:"critical" },
  { zone:"Panchvati",      heatRisk:68, dehydrationRisk:64, injuryRisk:52, epidemicRisk:18, overallRisk:"high"     },
  { zone:"Trimbakeshwar",  heatRisk:61, dehydrationRisk:58, injuryRisk:46, epidemicRisk:16, overallRisk:"high"     },
  { zone:"Nashik Road Stn",heatRisk:48, dehydrationRisk:44, injuryRisk:38, epidemicRisk:12, overallRisk:"moderate" },
  { zone:"Kalaram Temple", heatRisk:42, dehydrationRisk:38, injuryRisk:32, epidemicRisk:10, overallRisk:"moderate" },
  { zone:"Gangapur Camp",  heatRisk:28, dehydrationRisk:24, injuryRisk:21, epidemicRisk:8,  overallRisk:"normal"   },
];

export const diseaseAlerts = [
  { disease:"Heatstroke cluster",   zone:"Ramkund Ghat — Zone C",  cases:14, trend:"rising",   risk:"HIGH",   action:"Medical team dispatched" },
  { disease:"Dehydration surge",    zone:"Panchvati Entry",         cases:22, trend:"stable",   risk:"HIGH",   action:"ORS distribution active" },
  { disease:"Gastroenteritis watch",zone:"Gangapur Food Zone",      cases:4,  trend:"stable",   risk:"MED",    action:"FSSAI inspection ordered" },
  { disease:"Respiratory symptoms", zone:"Trimbakeshwar, Zone A",   cases:6,  trend:"falling",  risk:"LOW",    action:"Monitoring" },
];

// ── Transport ─────────────────────────────────────────────────
export const transportData = {
  railway: { load:72, trains:38, delayed:4 },
  bus:     { load:78, buses:210, delayed:6 },
  shuttle: { load:74, shuttles:120, delayed:3 },
  parking: { load:71, zones:52, full:8 },
  mobilityFlow:[
    { time:"05:00", railway:8000,  bus:12000, shuttle:5000  },
    { time:"06:00", railway:18000, bus:26000, shuttle:11000 },
    { time:"07:00", railway:34000, bus:44000, shuttle:20000 },
    { time:"08:00", railway:52000, bus:66000, shuttle:31000 },
    { time:"09:00", railway:68000, bus:82000, shuttle:42000 },
    { time:"10:00", railway:75000, bus:90000, shuttle:48000 },
    { time:"11:00", railway:78000, bus:95000, shuttle:51000 },
  ],
};

export const trafficCorridors = [
  { name:"Mumbai-Nashik NH3",       load:88, dist:"167 km", status:"Heavy",     prediction:"91% at 13:00" },
  { name:"Nashik-Trimbak Road",     load:72, dist:"28 km",  status:"Moderate",  prediction:"78% at 14:00" },
  { name:"Godavari Bridge",         load:91, dist:"0.4 km", status:"Critical",  prediction:"94% at 12:30" },
  { name:"Panchvati Road",          load:58, dist:"3 km",   status:"Moderate",  prediction:"65% at 14:00" },
  { name:"Gangapur Road",           load:44, dist:"6 km",   status:"Normal",    prediction:"48% at 15:00" },
  { name:"Gadkari Chowk Junction",  load:82, dist:"0.2 km", status:"High",      prediction:"85% at 13:30" },
];

export const trainSchedule = [
  { train:"Panchavati Exp. 12102",  from:"Mumbai CST",   arrival:"14:42", status:"On Time", load:94, platform:2 },
  { train:"Ganga-Kaveri 16352",     from:"Secunderabad",  arrival:"15:08", status:"Delayed", load:88, platform:1 },
  { train:"Nashik Express 11027",   from:"Pune",          arrival:"15:22", status:"On Time", load:76, platform:3 },
  { train:"Tapovan Express 12533",  from:"Mumbai",        arrival:"16:14", status:"On Time", load:82, platform:2 },
  { train:"Godavari Exp. 12727",    from:"Hyderabad",     arrival:"17:30", status:"On Time", load:68, platform:4 },
];

// ── Pilgrim guidance ──────────────────────────────────────────
export const pilgrimGuidance = {
  whatsapp:18640,
  sms:     12380,
  ivr:      8920,
  helpDesk: 3240,
  languages:[
    { name:"Marathi",  value:42, color:"#F59E0B" },
    { name:"Hindi",    value:32, color:"#2563EB"  },
    { name:"English",  value:12, color:"#7C3AED"  },
    { name:"Gujarati", value:9,  color:"#10B981"  },
    { name:"Others",   value:5,  color:"#64748B"  },
  ],
  categories:[
    { name:"Route Guidance",   count:11240 },
    { name:"Lost Person",      count:4180  },
    { name:"Medical Help",     count:3620  },
    { name:"Transport Info",   count:7840  },
    { name:"Shelter/Food",     count:5920  },
    { name:"General Info",     count:6380  },
  ],
};

export const pilgrimAdvisories = [
  { id:"ADV-114", type:"Route",     message:"Entry Gate 2 Ramkund is at capacity. Use Gate 4 via Godavari Bridge.",    lang:"Marathi/Hindi", reach:82400, time:"14:20", verified:true  },
  { id:"ADV-113", type:"Medical",   message:"Free medical camps at Panchvati, Camp Beta. Water ORS available.",          lang:"Marathi",       reach:64200, time:"14:10", verified:true  },
  { id:"ADV-112", type:"Transport", message:"MSRTC shuttle SR-04 delayed. Next bus in 22 min at Bay 7.",                lang:"Hindi/Marathi", reach:44100, time:"13:58", verified:true  },
  { id:"ADV-111", type:"Safety",    message:"Carry water. Temperature 38°C. Avoid crowd density areas near Ramkund.",    lang:"All",           reach:124000,time:"13:30", verified:true  },
  { id:"ADV-110", type:"Missing",   message:"Missing child (Boy ~7yr, yellow kurta) last seen Panchvati Sector 7.",      lang:"Marathi/Hindi", reach:22000, time:"14:12", verified:true  },
];

// ── Missing persons ───────────────────────────────────────────
export const missingPersonData = {
  // Kept in sync with `cases` below — total = cases.length; resolved = cases
  // no longer actively missing (status "Resolved" or "Located"); children/
  // elderly/disabled/medRisk are demographic highlight counts from the case
  // list. Pages should prefer deriving Active/Located/Resolved counts
  // directly from `cases` (e.g. `cases.filter(c => c.status === "Active")`)
  // rather than re-deriving them arithmetically from these summary fields.
  children:3,
  elderly: 3,
  disabled:1,
  medRisk: 1,
  resolved:4,
  total:   8,
  cases:[
    { id:"MP-1185", name:"Unknown Child ~7yrs",   category:"Child",    reportedAt:"14:18", zone:"Panchvati Sector 7",    status:"Active",   assignee:"UNIT-P16",   phone:"+91-8888" },
    { id:"MP-1184", name:"Elderly Male ~74yrs",    category:"Elderly",  reportedAt:"14:02", zone:"Ramkund Entry 2",       status:"Located",  assignee:"UNIT-P27",   phone:"+91-9221" },
    { id:"MP-1183", name:"Disabled Female ~52yrs", category:"Disabled", reportedAt:"13:44", zone:"Kalaram Gate 3",        status:"Active",   assignee:"UNIT-P14",   phone:"+91-7714" },
    { id:"MP-1182", name:"Male ~48yrs",            category:"Adult",    reportedAt:"13:22", zone:"Trimbakeshwar Zone A",  status:"Resolved", assignee:"UNIT-P12",   phone:"+91-9876" },
    { id:"MP-1181", name:"Child ~5yrs, Girl",      category:"Child",    reportedAt:"13:05", zone:"Nashik Road Camp",      status:"Resolved", assignee:"UNIT-P22",     phone:"+91-7654" },
    { id:"MP-1180", name:"Elderly Female ~68yrs",  category:"Elderly",  reportedAt:"12:48", zone:"Panchvati South",       status:"Resolved", assignee:"UNIT-P16",   phone:"+91-6543" },
    { id:"MP-1179", name:"Unknown Male ~60yrs",    category:"Elderly",  reportedAt:"12:30", zone:"Gangapur Camp Zone B",  status:"Active",   assignee:"UNIT-P28",    phone:"+91-5432" },
    { id:"MP-1178", name:"Child ~8yrs, Boy",       category:"Child",    reportedAt:"12:14", zone:"Kalaram Temple Area",   status:"Active",   assignee:"UNIT-P13",phone:"+91-4321" },
  ],
};

// ── War room ──────────────────────────────────────────────────
export const warRoomTasks = {
  police:[
    { id:"POL-001", title:"Crowd control Ramkund Entry 2",      priority:"HIGH", status:"in_progress", owner:"DCP Nashik",    sla:"14:50" },
    { id:"POL-002", title:"VIP convoy route — CM Nashik visit",  priority:"HIGH", status:"pending",     owner:"SP Nashik",    sla:"15:30" },
    { id:"POL-003", title:"Missing child — Panchvati Sector 7",  priority:"HIGH", status:"in_progress", owner:"UNIT-P22",   sla:"15:00" },
  ],
  health:[
    { id:"HLT-001", title:"Camp Alpha — capacity relief needed", priority:"MED",  status:"in_progress", owner:"CMO Nashik",   sla:"15:10" },
    { id:"HLT-002", title:"Additional ambulance — Trimbak",      priority:"HIGH", status:"approved",    owner:"UNIT-H05", sla:"14:55" },
  ],
  transport:[
    { id:"TRP-001", title:"Shuttle SR-04 diversion Trimbak",     priority:"MED",  status:"in_progress", owner:"MSRTC Nashik", sla:"15:20" },
    { id:"TRP-002", title:"Extra buses Nashik Road → Ramkund",   priority:"MED",  status:"approved",    owner:"RTO Office",  sla:"15:45" },
  ],
  municipal:[
    { id:"MUN-001", title:"Toilet blocks — deep clean Panchvati",priority:"MED",  status:"pending",     owner:"NMC Sanitation",sla:"16:00"},
    { id:"MUN-002", title:"Water tanker refill Station 8",        priority:"HIGH", status:"in_progress", owner:"JE NMC",      sla:"14:58" },
  ],
  disaster:[
    { id:"DIS-001", title:"Flash flood prep — Godavari banks",   priority:"MED",  status:"pending",     owner:"NDRF Team B", sla:"17:00" },
  ],
};

export const warRoomSITREP = {
  generatedAt: "14:35, 9 June 2027",
  crowdStatus: "6,84,210 pilgrims active. Ramkund Ghat at critical 92% density. Panchvati at 81%.",
  incidentSummary: "18 open incidents: 6 critical, 9 high, 3 medium. 57 resolved since 06:00.",
  resourceStatus: "Police: 6,420 deployed. Health: 1,680. NDRF on standby. 34 ambulances active.",
  nextShahiSnan: "11 July 2027 (Shravan Purnima) — Peak day estimate 9 lakh.",
  actionItems: [
    "Reinforce Ramkund Entry 2 with 3 additional platoons — DCP Nashik",
    "Redirect water tanker T-14 to Station 8 — JE NMC (ETA 12 min)",
    "Open Camp Delta for shelter overflow — Revenue Dept",
    "Activate CM communication protocol for VIP visit — SP Nashik",
  ],
};

export const agencyCoordination = [
  { dept:"Police",        tasks:12, completed:9,  pending:3, slaBreaches:0, lastActivity:"14:32" },
  { dept:"Health",        tasks:8,  completed:6,  pending:2, slaBreaches:0, lastActivity:"14:28" },
  { dept:"Transport",     tasks:6,  completed:4,  pending:2, slaBreaches:1, lastActivity:"14:21" },
  { dept:"Municipal NMC", tasks:5,  completed:3,  pending:2, slaBreaches:0, lastActivity:"14:18" },
  { dept:"NDRF",          tasks:3,  completed:3,  pending:0, slaBreaches:0, lastActivity:"14:15" },
  { dept:"Revenue",       tasks:4,  completed:3,  pending:1, slaBreaches:0, lastActivity:"14:10" },
  { dept:"CM Office",     tasks:2,  completed:2,  pending:0, slaBreaches:0, lastActivity:"14:08" },
];

// ── Public communications ─────────────────────────────────────
export const publicComms = {
  verifiedAlerts: 42,
  advisories:     24,
  misinfoReports:  9,
  mediaUpdates:   16,
  trustScore:     87.6,
  messageReach:   3840000,
  reachTrend:[
    { hour:"06:00", reach:210000,  engagement:48000  },
    { hour:"07:00", reach:520000,  engagement:118000 },
    { hour:"08:00", reach:1080000, engagement:242000 },
    { hour:"09:00", reach:1840000, engagement:410000 },
    { hour:"10:00", reach:2680000, engagement:594000 },
    { hour:"11:00", reach:3840000, engagement:840000 },
  ],
};

export const misinformationAlerts = [
  { id:"MIS-28", platform:"WhatsApp",  content:"Fake alert: Ramkund closed for 3 hours",         severity:"HIGH",  status:"Corrected", reach:42000, time:"14:10" },
  { id:"MIS-27", platform:"Twitter/X", content:"False rumour: stampede at Panchvati",             severity:"HIGH",  status:"Flagged",   reach:18000, time:"13:48" },
  { id:"MIS-26", platform:"Facebook",  content:"Incorrect route advisory spreading",              severity:"MED",   status:"Corrected", reach:28000, time:"13:20" },
  { id:"MIS-25", platform:"SMS chain", content:"Wrong medical camp location circulating",         severity:"MED",   status:"Corrected", reach:12000, time:"12:44" },
];

export const mediaChannels = [
  { channel:"DD Sahyadri",      type:"TV",      reach:"12.4M", status:"Active",   lastUpdate:"14:30" },
  { channel:"AIR Nashik",       type:"Radio",   reach:"4.2M",  status:"Active",   lastUpdate:"14:25" },
  { channel:"Lokmat",           type:"Print",   reach:"2.8M",  status:"Active",   lastUpdate:"13:00" },
  { channel:"Official WhatsApp",type:"Digital", reach:"1.8M",  status:"Active",   lastUpdate:"14:32" },
  { channel:"Govt Website",     type:"Web",     reach:"0.9M",  status:"Active",   lastUpdate:"14:20" },
  { channel:"Sarkari App",      type:"App",     reach:"0.6M",  status:"Active",   lastUpdate:"14:28" },
];

// ── Governance / DPDP ─────────────────────────────────────────
export const governanceData = {
  privacyScore:     97.1,
  auditLogs:        22840,
  accessAlerts:     2,
  dataMinimization: 95.4,
  humanReview:      86.9,
  securityEvents:[
    { time:"07:00", events:3,  alerts:0 },
    { time:"08:00", events:6,  alerts:0 },
    { time:"09:00", events:9,  alerts:1 },
    { time:"10:00", events:8,  alerts:0 },
    { time:"11:00", events:12, alerts:1 },
    { time:"12:00", events:7,  alerts:0 },
    { time:"13:00", events:5,  alerts:0 },
  ],
  accessActivity:[
    { role:"CM Office",      logins:2,    actions:38   },
    { role:"District Admin", logins:18,   actions:284  },
    { role:"Police",         logins:182,  actions:2640 },
    { role:"Health",         logins:94,   actions:1280 },
    { role:"Transport",      logins:62,   actions:840  },
    { role:"Field Officer",  logins:1120, actions:8640 },
  ],
};

export const dpdpCompliance = [
  { control:"Data Minimisation",        status:"Compliant",   score:96, lastAudit:"09 Jun 2027",  notes:"Only operational data collected"          },
  { control:"Consent Management",       status:"Compliant",   score:94, lastAudit:"09 Jun 2027",  notes:"Consent recorded for all biometric use"    },
  { control:"Purpose Limitation",       status:"Compliant",   score:98, lastAudit:"08 Jun 2027",  notes:"Data used only for safety operations"       },
  { control:"Data Retention",           status:"Compliant",   score:92, lastAudit:"08 Jun 2027",  notes:"30-day retention policy active"             },
  { control:"Right to Erasure",         status:"Implemented", score:88, lastAudit:"07 Jun 2027",  notes:"Portal active, 2 requests processed"        },
  { control:"Privacy by Design",        status:"Compliant",   score:95, lastAudit:"09 Jun 2027",  notes:"Anonymisation at source in camera feeds"    },
  { control:"No Punitive AI Action",    status:"Enforced",    score:100,lastAudit:"09 Jun 2027",  notes:"Human-in-loop mandatory for enforcement"    },
  { control:"AI Explainability",        status:"Compliant",   score:91, lastAudit:"08 Jun 2027",  notes:"SHAP explanations available for all models" },
];

export const auditLogEntries = [
  { id:"AUD-9912", user:"DCP Nashik",       action:"Approved crowd diversion — Entry 2",         resource:"Incident INC-8821", time:"14:33", role:"Police L2" },
  { id:"AUD-9911", user:"CMO Nashik",        action:"Reviewed AI heatstroke flag Zone D",          resource:"Alert RV-4419",     time:"14:22", role:"Health L2"  },
  { id:"AUD-9910", user:"UNIT-M43",    action:"Logged water tanker delay — Station 8",       resource:"Incident INC-8820", time:"14:18", role:"Municipal"  },
  { id:"AUD-9909", user:"MSRTC Nashik",      action:"Updated shuttle SR-04 diversion route",       resource:"TRP-001",           time:"14:14", role:"Transport"  },
  { id:"AUD-9908", user:"AI System",         action:"Auto-suppressed duplicate fire alert Trimbak", resource:"Alert INC-8817",   time:"14:02", role:"System"     },
  { id:"AUD-9907", user:"UNIT-P16",      action:"Initiated MP search — MP-1185",               resource:"Case MP-1185",      time:"14:00", role:"Police L1"  },
  { id:"AUD-9906", user:"UNIT-H05",   action:"Escalated ambulance block — Camp Beta",       resource:"Incident INC-8819", time:"13:58", role:"Health L2"  },
  { id:"AUD-9905", user:"SP Nashik",         action:"Approved CM convoy route — POL-002",           resource:"Task POL-002",      time:"13:44", role:"Police L3"  },
];

export const rbacRoles = [
  { role:"CM Office",      level:"L4 — National",    users:2,   permissions:"View-all, Approve-escalations",          twoFA:true  },
  { role:"Collector",      level:"L3 — District",    users:4,   permissions:"View-all, Approve-operations",           twoFA:true  },
  { role:"SP / DCP",       level:"L2 — Dept Head",   users:12,  permissions:"View-dept, Approve-tasks, Assign",       twoFA:true  },
  { role:"Section Officer",level:"L2 — Dept",        users:48,  permissions:"View-dept, Execute-tasks",               twoFA:true  },
  { role:"Field Officer",  level:"L1 — Field",       users:1120,"permissions":"View-assigned, Update-status",         twoFA:false },
  { role:"Read Only",      level:"L0 — Observer",    users:22,  permissions:"View-summary only",                      twoFA:false },
];

export const cyberEvents = [
  { id:"SEC-441", type:"Unauthorised Access Attempt", source:"External IP 203.x.x.x",  severity:"HIGH",   status:"Blocked",    time:"14:28" },
  { id:"SEC-440", type:"API Rate Limit Breach",       source:"Mobile App Agent",        severity:"MED",    status:"Throttled",  time:"14:12" },
  { id:"SEC-439", type:"Unusual Login Pattern",       source:"Field Officer FO-1140",   severity:"LOW",    status:"Monitored",  time:"13:44" },
  { id:"SEC-438", type:"Data Export Attempt",         source:"External Partner System", severity:"HIGH",   status:"Blocked",    time:"12:58" },
  { id:"SEC-437", type:"Certificate Expiry Warning",  source:"API Gateway Cert",        severity:"MED",    status:"Renewing",   time:"12:00" },
];

// ── Field officers ────────────────────────────────────────────
export const fieldOfficerAlerts = [
  {
    id:"INC-8821",
    issue:"Crowd surge — density > 9/m² at Ramkund",
    location:"Ramkund Ghat, Entry Gate 2, Nashik",
    severity:"HIGH",
    owner:"UNIT-P22",
    sop:["Deploy 3 additional platoons at Entry 2","Activate crowd diversion via Godavari Route B","Alert medical standby team at Camp Alpha","Close Entry 2 if density exceeds 10/m²","Update War Room every 5 min"],
    escalation:"14:50",
    status:"In Progress",
    aiConfidence:91,
  },
  {
    id:"INC-8820",
    issue:"Water tanker not arrived — Station 8, Panchvati",
    location:"Panchvati Zone, Water Point 8, Nashik",
    severity:"MED",
    owner:"UNIT-M43",
    sop:["Contact tanker contractor immediately","Redirect nearest NMC tanker (T-14, ETA 12 min)","Inform pilgrims via PA system","Log breach in audit trail"],
    escalation:"15:15",
    status:"Pending",
    aiConfidence:87,
  },
  {
    id:"INC-8819",
    issue:"Ambulance access blocked — medical emergency",
    location:"Medical Camp Beta, Trimbakeshwar Road",
    severity:"HIGH",
    owner:"UNIT-H05",
    sop:["Request police escort immediately","Clear Trimbak Road obstruction via Zone B officer","Stabilise patient at Camp Beta until ambulance arrives","Escalate to DCP if not cleared in 5 min"],
    escalation:"14:44",
    status:"In Progress",
    aiConfidence:94,
  },
];

/* Deployed units, identified by call-sign rather than by personal name.
   The names here were invented; a fabricated officer name shown on a
   government-facing board reads as a real roster to anyone who does not
   know otherwise. A call-sign conveys the same operational picture and
   claims nothing about a person. */
export const officerLocations = [
  { unit:"UNIT-P11",           zone:"Ramkund Ghat",    status:"Responding", task:"Crowd Control",   lastUpdate:"14:32" },
  { unit:"UNIT-P24",          zone:"Panchvati",        status:"On Duty",    task:"Missing Person Search", lastUpdate:"14:28" },
  { unit:"UNIT-P07",          zone:"Kalaram Temple",   status:"On Duty",    task:"Entry Gate Mgmt", lastUpdate:"14:24" },
  { unit:"UNIT-H03",          zone:"Trimbak Rd Camp",  status:"Emergency",  task:"Ambulance Coord", lastUpdate:"14:22" },
  { unit:"UNIT-N15",          zone:"Panchvati Zone",   status:"In Progress",task:"Water Supply",    lastUpdate:"14:18" },
  { unit:"UNIT-P31",          zone:"Nashik Road Stn",  status:"On Duty",    task:"Transport Coord", lastUpdate:"14:15" },
];

// ── Digital twin / simulations ─────────────────────────────────
export const simulationScenarios = [
  { id:1, name:"Shahi Snan — Simhastha Peak",  icon:"Waves",       riskLevel:"HIGH",     crowdEst:"9,00,000", criticalZones:5, evacTime:"32 min", status:"Simulated" },
  { id:2, name:"Godavari Bridge Closure",       icon:"Route",       riskLevel:"MED",      crowdEst:"6,20,000", criticalZones:3, evacTime:"26 min", status:"Simulated" },
  { id:3, name:"Emergency Mass Evacuation",     icon:"AlertOctagon",riskLevel:"CRITICAL", crowdEst:"6,84,000", criticalZones:7, evacTime:"21 min", status:"Ready"     },
  { id:4, name:"Godavari Flood — Monsoon Risk", icon:"CloudRain",   riskLevel:"MED",      crowdEst:"4,20,000", criticalZones:4, evacTime:"38 min", status:"Simulated" },
];

export const commandTimeline = [
  { time:"14:33", type:"escalation", msg:"DCP Nashik approved crowd diversion — Ramkund Entry 2",    dept:"Police"   },
  { time:"14:28", type:"alert",      msg:"Water station #8 at 91% capacity — Panchvati",              dept:"Municipal"},
  { time:"14:22", type:"action",     msg:"CMO reviewed heatstroke flag — Zone D, AI confidence 78%",  dept:"Health"   },
  { time:"14:18", type:"missing",    msg:"Missing child MP-1185 registered — Panchvati Sector 7",     dept:"Police"   },
  { time:"14:12", type:"ai",         msg:"AI duplicate fire alert suppressed — Trimbak Zone A",        dept:"System"   },
  { time:"14:08", type:"resolved",   msg:"Missing person MP-1182 located and reunited",                dept:"Police"   },
  { time:"14:02", type:"action",     msg:"Extra MSRTC buses deployed — Nashik Road → Ramkund",        dept:"Transport"},
  { time:"13:55", type:"escalation", msg:"Shelter Camp 3 at 94% — escalated to Revenue Dept",         dept:"Revenue"  },
  { time:"13:44", type:"resolved",   msg:"Godavari Bridge congestion cleared — Police escort",         dept:"Police"   },
  { time:"13:30", type:"advisory",   msg:"Public advisory broadcast — Marathi/Hindi — 82K reach",     dept:"Comms"    },
];
